// export const ENV = process.env.NODE_ENV
// export const ENV = 'test'

const { host, port } = window.location;
// const IS_DEBUG = !!localStorage.getItem('_DEBUG_');

/** 当前环境类型 */
type Environment = 'daily' | 'dev' | 'pre' | 'prod';

/** 当前环境: daily, pre, prod */
export const ENV: Environment = /127.0.0.1|localhost|local|daily|test/.test(host)
  ? 'daily'
  : /dev|stosystem/.test(host)
  ? ( port === '3000' ? 'dev' : 'daily' )
  : /pre-/.test(host)
  ? 'pre'
  : 'prod';

export const isProd: boolean = !['test', 'development'].includes(ENV); 